export default "__VITE_ASSET__SiXgJZAe__"